export default function getRouterPath(fullPath) {
  try {
    const components = fullPath.split('/');
    const path = components[1];
    return path;
  } catch (error) {
    return '';
  }
}
